export default __webpack_public_path__ + "static/media/graduation.69534888.svg";